import { render, staticRenderFns } from "./CustomLabels.vue?vue&type=template&id=1376d080&"
import script from "./CustomLabels.vue?vue&type=script&lang=js&"
export * from "./CustomLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports